module.exports = __webpack_public_path__ + "static/media/and.d1685084.svg";